import { useParams } from 'react-router-dom';
import cl from './NewsCard.module.css';
import React from "react";

const NewsCard = (props) => {
  const newsPath = useParams().path;
  const news = props.newsData.find((news) => news.path === newsPath);
    return (
      <section className={cl.news_card_container}>
        <h2>{news.newsName}</h2>
        <img className={cl.big_image} src={news.bigNewsImg} alt="" />
        <div className={cl.news_block}>
          <p>{news.text1}</p>
          <div className={cl.vertical_line}></div>
          <img className={cl.image} src={news.img1} alt="" />
        </div>
        
      </section>
    );
}

export default NewsCard;